module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-container"
  }, [_c('p', {
    staticClass: "page-header"
  }, [_vm._v("404")]), _vm._v(" "), _c('p', {
    staticClass: "page-body"
  }, [_vm._v("抱歉！您访问的页面不存在，请重新加载......")]), _vm._v(" "), _c('el-link', {
    staticClass: "page-return",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.returnHomePage
    }
  }, [_vm._v("< 返回主页")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e9fdaaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 697
// module chunks = 1